import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/CesiumScene.vue'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            // component: Home,
            component: () => import('../AppExampleAnt.vue')
        },
        // {
        //     path: '/about',
        //     name: 'about',
        //     component: () => import('../AppExample.vue')
        // }, 
        {
            path: '/demo',
            component: () => import('../demo/home.vue'),
            children: [  //————————————地球————————————
                {
                    path: 'earth',
                    name: 'earth',
                    component: () => import('../demo/earth/3DEarth.vue')
                },
                //Google 遥感影像
                {
                    path: 'GoogleImg',
                    name: 'GoogleImg',
                    component: () => import('../demo/earth/GoogleImg.vue')
                },
                //地形图
                {
                    path: 'terrain',
                    name: 'terrain',
                    component: () => import('../demo/earth/terrain.vue')
                },
                //矢量点
                {
                    path: 'vectorpoint',
                    name: 'vectorpoint',
                    component: () => import('../demo/earth/vector_point.vue')
                },
                //图标
                {
                    path: 'icons',
                    name: 'icons',
                    component: () => import('../demo/earth/Icons.vue')
                },
                //标记
                {
                    path: 'sign',
                    name: 'sign',
                    component: () => import('../demo/earth/Sign.vue')
                },
                //行政区划面
                {
                    path: 'adface',
                    name: 'adface',
                    component: () => import('../demo/earth/adminiface.vue')
                },
                //文字
                {
                    path: 'words',
                    name: 'words',
                    component: () => import('../demo/earth/words.vue')
                },
                //23点
                {
                    path: 'htmlText',
                    name: 'htmlText',
                    component: () => import('../demo/earth/27htmlText.vue')
                },
                //空中漫游
                {
                    path: 'Sprotating',
                    name: 'Sprotating',
                    component: () => import('../demo/earth/Spatial_Roaming.vue')
                },
                //21、三维汽车沿路径移动
                {
                    path: 'groundRoaming',
                    name: 'groundRoaming',
                    component: () => import('../demo/earth/21groundRoaming.vue')
                },
                //旋转漫游
                {
                    path: 'Roamting',
                    name: 'Roamting',
                    component: () => import('../demo/earth/Rotate_Roaming.vue')
                },
                //地面漫游
                {
                    path: 'flooroaming',
                    name: 'flooroaming',
                    component: () => import('../demo/earth/flooroaming.vue')
                },
                //倾斜摄影模型
                {
                    path: 'tiltphot',
                    name: 'tiltphot',
                    component: () => import('../demo/scene/tiltphot.vue')
                },
                //三维路径移动
                {
                    path: 'carmoving',
                    name: 'carmoving',
                    component: () => import('../demo/earth/3DCar.vue')
                },
                //40、加载道路
                {
                    path: 'loadRoad',
                    name: 'loadRoad',
                    component: () => import('../demo/earth/40loadRoad.vue')
                },
                //41、加载北京行政区划（拔高）
                {
                    path: 'loadBeijing',
                    name: 'loadBeijing',
                    component: () => import('../demo/earth/41loadBeijing.vue')
                },
                //柱状图
                {
                    path: 'loadhisgram',
                    name: 'loadhisgram',
                    component: () => import('../demo/earth/Histogram.vue')
                },
                //雷达图
                {
                    path: 'radar2',
                    name: 'radar2',
                    component: () => import('../demo/earth/radar2.vue')
                },
                //雷达图
                {
                    path: 'radar',
                    name: 'radar',
                    component: () => import('../demo/earth/radar.vue')
                },
                //gif动态点
                {
                    path: 'poindymic',
                    name: 'poindymic',
                    component: () => import('../demo/earth/pointdynomic.vue')
                },
                //地形开挖效果
                {
                    path: 'excavation',
                    name: 'excavation',
                    component: () => import('../demo/earth/terrain_excavation.vue')
                },
                //模型
                {
                    path: 'addDelModel',
                    name: 'addDelModel',
                    component: () => import('../demo/model/46addDelModel.vue')
                },
                //模型效果
                {
                    path: 'modelAnimation',
                    name: 'modelAnimation',
                    component: () => import('../demo/model/modelAnimation.vue')
                },
                // 模型颜色透明
                {
                    path: 'modelAlpha',
                    name: 'modelAlpha',
                    component: () => import('../demo/modelEffect/54modelAlpha.vue')
                },
                // 模型贴图
                {
                    path: 'modelImageMaterial',
                    name: 'modelImageMaterial',
                    component: () => import('../demo/modelEffect/55modelImageMaterial.vue')
                },
                // 模型勾边
                {
                    path: 'modelBorder',
                    name: 'modelBorder',
                    component: () => import('../demo/modelEffect/56modelBorder.vue')
                },
                //粒子效果
                {
                    path: 'fog',
                    name: 'fog',
                    component: () => import('../demo/particle/fog.vue')
                },
                {
                    path: 'light',
                    name: 'light',
                    component: () => import('../demo/particle/light.vue')
                },
                {
                    path: 'fire',
                    name: 'fire',
                    component: () => import('../demo/particle/34fire.vue')
                },
                {
                    path: 'snow',
                    name: 'snow',
                    component: () => import('../demo/particle/35snow.vue')
                },
                {
                    path: 'rain',
                    name: 'rain',
                    component: () => import('../demo/particle/36rain.vue')
                },
                {
                    path: 'flood',
                    name: 'flood',
                    component: () => import('../demo/particle/37flood.vue')
                },
                //分析功能
                {
                    path: 'crossTerrain',
                    name: 'crossTerrain',
                    component: () => import('../demo/analyse/42crossTerrain.vue')
                },
                {
                    path: 'contourLine',
                    name: 'contourLine',
                    component: () => import('../demo/analyse/contourLine.vue')
                },
                {
                    path: 'bufferAnalyse',
                    name: 'bufferAnalyse',
                    component: () => import('../demo/analyse/newbuffer.vue')
                },
                {
                    path: 'visibleLine',
                    name: 'visibleLine',
                    component: () => import('../demo/analyse/visibility_analisy.vue')
                    // component: () => import('../demo/analyse/45visibleLine.vue')
                },
                {
                    path: 'shadowAnalyse',
                    name: 'shadowAnalyse',
                    component: () => import('../demo/analyse/72shadowAnalyse.vue')
                },
                {
                    path: 'efAnalysis',
                    name: 'efAnalysis',
                    component: () => import('../demo/analyse/efAnalyse.vue')
                },
                // 热力图
                {
                    path: 'headMap',
                    name: 'headMap',
                    component: () => import('../demo/use/headMap.vue')
                },
                // 添加标注
                {
                    path: 'marker',
                    name: 'marker',
                    component: () => import('../demo/use/marker.vue')
                },
                // 长度面积测量
                {
                    path: 'measure',
                    name: 'measure',
                    component: () => import('../demo/use/measure.vue')
                },
                // 鹰眼图
                {
                    path: 'eagleEye',
                    name: 'eagleEye',
                    component: () => import('../demo/use/eagleEye.vue')
                },
                // 双屏显示
                {
                    path: 'doubleScreen',
                    name: 'doubleScreen',
                    component: () => import('../demo/use/doubleScreen.vue')
                },
                // 鹰眼图(三维和二维的联动)
                {
                    path: 'linkage',
                    name: 'linkage',
                    component: () => import('../demo/use/linkage.vue')
                },
                // 模型编辑
                {
                    path: 'gltf',
                    name: 'gltf',
                    component: () => import('../demo/model/gltf.vue')
                },
                // 白天黑夜
                {
                    path: 'dayTime',
                    name: 'dayTime',
                    component: () => import('../demo/use/dayTime.vue')
                },
                // 绕点飞行
                {
                    path: 'caRotate',
                    name: 'caRotate',
                    component: () => import('../demo/camera/rotate.vue')
                },
                // 视角切换
                {
                    path: 'viewChange',
                    name: 'viewChange',
                    component: () => import('../demo/camera/viewChange.vue')
                },
                // 鼠标获取经纬度
                {
                    path: 'latlong',
                    name: 'latlong',
                    component: () => import('../demo/use/latlong.vue')
                },
                // 模型选择高亮
                {
                    path: 'getModel',
                    name: 'getModel',
                    component: () => import('../demo/model/getModel.vue')
                },
                // 模型动画
                {
                    path: 'modelAnimation2',
                    name: 'modelAnimation2',
                    component: () => import('../demo/model/modelAnimation2.vue')
                },
                // 模型拖拽
                {
                    path: 'modelDrag',
                    name: 'modelDrag',
                    component: () => import('../demo/model/modelDrag.vue')
                },
                // 模型位置
                {
                    path: 'modelLocation',
                    name: 'modelLocation',
                    component: () => import('../demo/model/modeLocation.vue')
                },
                // 加载实体
                {
                    path: 'addGeometry',
                    name: 'addGeometry',
                    component: () => import('../demo/hello/addGeometry.vue')
                },
                // 添加图层
                {
                    path: 'addImagery',
                    name: 'addImagery',
                    component: () => import('../demo/scene/addImagery.vue')
                },
                // 添加高德图层
                {
                    path: 'gaode',
                    name: 'gaode',
                    component: () => import('../demo/scene/gaode.vue')
                },
                // 添加mapbox图层
                {
                    path: 'mapbox',
                    name: 'mapbox',
                    component: () => import('../demo/scene/mapbox.vue')
                },
                // 添加学校模型
                {
                    path: 'school',
                    name: 'school',
                    component: () => import('../demo/scene/school.vue')
                },
                // 添加蓝海模型
                {
                    path: 'lanhai',
                    name: 'lanhai',
                    component: () => import('../demo/scene/lanhai.vue')
                },
                // 添加软件园模型
                {
                    path: 'rPark',
                    name: 'rPark',
                    component: () => import('../demo/scene/rPark.vue')
                },

                // // ljy 
                // // 智慧城市
                // {
                //     path: 'smartcity',
                //     name: 'smartcity',
                //     component: () => import('../demo/scene/smartcity.vue')
                // },

                // POI标记查询
                {
                    path: 'poi',
                    name: 'poi',
                    component: () => import('../demo/use/poi.vue')
                },
                // SmartMapXPOI标记查询
                {
                    path: 'sPoi',
                    name: 'sPoi',
                    component: () => import('../demo/use/sPoi.vue')
                },  // 人口分布网格图
                {
                    path: 'pRange',
                    name: 'pRange',
                    component: () => import('../demo/earth/pRange.vue')
                },
                // 视频
                {
                    path: 'video',
                    name: 'video',
                    component: () => import('../demo/video/vide.vue')
                },
                // 立体建筑物体块（高亮）
                {
                    path: 'lightModel',
                    name: 'lightModel',
                    component: () => import('../demo/earth/lightModel.vue')
                },
                // 叠加铁路网
                {
                    path: 'loadRailway',
                    name: 'loadRailway',
                    component: () => import('../demo/earth/loadRailway.vue')
                },
                // 光晕线
                {
                    path: 'lightLine',
                    name: 'lightLine',
                    component: () => import('../demo/earth/lightLine.vue')
                },
                // 流向动态线
                {
                    path: 'dynamicLine',
                    name: 'dynamicLine',
                    component: () => import('../demo/earth/dynamicLine.vue')
                },
                // 模型点击事件
                {
                    path: 'event',
                    name: 'event',
                    component: () => import('../demo/model/eventmodel.vue')
                },
                // 飞行动态线
                {
                    path: 'flyLine',
                    name: 'flyLine',
                    component: () => import('../demo/earth/flyLine.vue')
                },
                // 单体对象模型查询
                {
                    path: 'entitySearch',
                    name: 'entitySearch',
                    component: () => import('../demo/use/entitySearch.vue')
                },
                // 点云模型
                {
                    path: 'las',
                    name: 'las',
                    component: () => import('../demo/scene/las.vue')
                },
                // 剪裁分析
                {
                    path: 'clip',
                    name: 'clip',
                    component: () => import('../demo/analyse/clip.vue')
                },
                // 控高分析
                {
                    path: 'height',
                    name: 'height',
                    component: () => import('../demo/analyse/height.vue')
                },
                // 地下渲染
                {
                    path: 'underG',
                    name: 'underG',
                    component: () => import('../demo/analyse/underG.vue')
                },
                // 挖填方分析
                {
                    path: 'efAnalyse',
                    name: 'efAnalyse',
                    component: () => import('../demo/analyse/efAnalyse.vue')
                }, {
                    path: 'hot',
                    name: 'hot',
                    component: () => import('../demo/hot/hot.vue')
                },


            ]
        },
        {
            path: '/*',
            name: 'nofound',
            component: () => import('../components/NoFound.vue')
        },
    ]
})
